module.exports = __webpack_public_path__ + "img/sortBy-arrow-gray.5421e0ea.svg";